import { ITags } from "@formant/core/model/ITags";
import { ITypeaheadOption } from "@formant/ui-kit";

export const convertTagsToTypeaheadOptions = (
    tags: ITags,
    disabledTags?: ITags,
): ITypeaheadOption[] => {
    return Object.entries(tags).map(([key, value]) => ({
        key,
        value,
        deleteDisabled: disabledTags?.[key] === value,
    }));
};
